import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/i18n";
// Apply saved theme immediately before React mounts to avoid a light flash
if (typeof window !== "undefined") {
  try {
    if (window.localStorage.getItem("oresto-theme") === "dark") {
      document.documentElement.classList.add("dark");
    }
  } catch {}

  // Suppress opaque cross-origin "Script error." coming from 3rd party scripts
  // (Google Tag Manager, Meta Pixel, browser extensions). Without message/filename/lineno,
  // these errors have no actionable payload — they were surfacing in the CRA dev overlay
  // and blocking the Emergent preview panel.
  window.addEventListener(
    "error",
    (e) => {
      const isOpaqueScriptError =
        e && e.message === "Script error." && !e.filename && !e.lineno && !e.error;
      if (isOpaqueScriptError) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
      return undefined;
    },
    true,
  );
  window.addEventListener("unhandledrejection", (e) => {
    // Ignore unhandled rejections from 3rd party scripts we can't inspect
    if (e && e.reason && typeof e.reason === "object" && e.reason.stack === undefined && !e.reason.message) {
      e.preventDefault();
    }
  });
}
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register PWA service worker on any HTTPS host (skip localhost dev)
if (
  typeof window !== "undefined" &&
  "serviceWorker" in navigator &&
  window.location.protocol === "https:" &&
  window.location.hostname !== "localhost"
) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
